'use strict';
var base = require('base/checkout/address');
/**
 * Populate the Billing Address Summary View
 * @param {string} parentSelector - the top level DOM selector for a unique address summary
 * @param {Object} address - the address data
 */
function populateAddressSummary(parentSelector, address) {
    $.each(address, function (attr) {
        var val = address[attr];
        if (attr === 'address1') {
            var text = val;
            text += ' ' + address.custom.number;
            if (address.custom.apartment) {
                text = text + ' ' + address.custom.apartment;
            }
            if (address.custom.observation) {
                text = text + ' ' + address.custom.observation;
            }
            $('.' + attr, parentSelector).text(
                text
            );
        } else if (attr === 'stateCode') {
            $('.' + attr, parentSelector).text(
                address.custom.state ? address.custom.state : ' '
            );
        } else {
            if (attr === 'city') {
                val += ', ';
            }
            $('.' + attr, parentSelector).text(val || '');
        }
        if (address.custom.storeHours) {
            $('.storeHours', parentSelector).text(
                address.custom.storeHours ? address.custom.storeHours : ' '
            );
        } else {
            $('.storeHours', parentSelector).text(
                ' '
            );
        }
    });
}

/**
 * returns a formed <option /> element
 * @param {Object} shipping - the shipping object (shipment model)
 * @param {boolean} selected - current shipping is selected (for PLI)
 * @param {order} order - the Order model
 * @param {Object} [options] - options
 * @returns {Object} - the jQuery / DOMElement
 */
function optionValueForAddress(shipping, selected, order, options) {
    var safeOptions = options || {};
    var isBilling = safeOptions.type && safeOptions.type === 'billing';
    var className = safeOptions.className || '';
    var isSelected = selected;
    var isNew = !shipping;
    if (typeof shipping === 'string') {
        return $(
            '<option class="' +
            className +
            '" disabled>' +
            shipping +
            '</option>'
        );
    }
    var safeShipping = shipping || {};
    var shippingAddress = safeShipping.shippingAddress || {};

    if (isBilling && isNew && !order.billing.matchingAddressId) {
        shippingAddress = order.billing.billingAddress.address || {};
        isNew = false;
        isSelected = true;
        safeShipping.UUID = 'manual-entry';
    }

    var uuid = safeShipping.UUID ? safeShipping.UUID : 'new';
    var optionEl = $('<option class="' + className + '" />');
    optionEl.val(uuid);

    var title;

    if (isNew) {
        title = order.resources.addNewAddress;
    } else {
        title = [];
        if (shippingAddress.firstName) {
            title.push(shippingAddress.firstName);
        }
        if (shippingAddress.lastName) {
            title.push(shippingAddress.lastName);
        }
        if (shippingAddress.address1) {
            title.push(shippingAddress.address1);
        }
        if (shippingAddress.custom) {
            if (shippingAddress.custom.number) {
                title.push(shippingAddress.custom.number);
            }
            if (shippingAddress.custom.apartment) {
                title.push(shippingAddress.custom.apartment);
            }
        }
        if (shippingAddress.city) {
            if (shippingAddress.state) {
                title.push(shippingAddress.city + ',');
            } else {
                title.push(shippingAddress.city);
            }
        }
        if (shippingAddress.custom) {
            if (shippingAddress.custom.state) {
                title.push(shippingAddress.custom.state);
            }
        }
        if (shippingAddress.postalCode) {
            title.push(shippingAddress.postalCode);
        }
        if (!isBilling && safeShipping.selectedShippingMethod) {
            title.push('-');
            title.push(safeShipping.selectedShippingMethod.displayName);
        }

        if (title.length > 2) {
            title = title.join(' ');
        } else {
            title = order.resources.newAddress;
        }
    }
    optionEl.text(title);

    var keyMap = {
        'data-first-name': 'firstName',
        'data-last-name': 'lastName',
        'data-address1': 'address1',
        'data-address2': 'address2',
        'data-city': 'city',
        'data-state-code': 'stateCode',
        'data-postal-code': 'postalCode',
        'data-country-code': 'countryCode',
        'data-custom-number': 'number',
        'data-custom-apartment': 'apartment',
        'data-custom-observation': 'observation',
        'data-phone': 'phone'
    };
    $.each(keyMap, function (key) {
        var mappedKey = keyMap[key];
        var mappedValue;
        if (key.includes('custom')) {
            if (shippingAddress.custom && shippingAddress.custom[mappedKey]) {
                mappedValue = shippingAddress.custom[mappedKey];
            }
        } else {
            mappedValue = shippingAddress[mappedKey];
            // In case of country code
            if (mappedValue && typeof mappedValue === 'object') {
                mappedValue = mappedValue.value;
            }
        }

        optionEl.attr(key, mappedValue || '');
    });

    var giftObj = {
        'data-is-gift': 'isGift',
        'data-gift-message': 'giftMessage'
    };

    $.each(giftObj, function (key) {
        var mappedKey = giftObj[key];
        var mappedValue = safeShipping[mappedKey];
        optionEl.attr(key, mappedValue || '');
    });

    optionEl.attr('data-selected-shipping-method', order.selectedShippingMethod);

    if (isSelected) {
        optionEl.attr('selected', true);
    }

    return optionEl;
}

/**
 * returns address properties from a UI form
 * @param {Form} form - the Form element
 * @returns {Object} - a JSON object with all values
 */
function getAddressFieldsFromUI(form) {
    var address = {
        firstName: $('input[name$=_firstName]', form).val(),
        lastName: $('input[name$=_lastName]', form).val(),
        address1: $('input[name$=_address1]', form).val(),
        city: $('input[name$=_city]', form).val(),
        postalCode: $('input[name$=_postalCode]', form).val(),
        stateCode: $(
            'select[name$=_stateCode],input[name$=_stateCode]',
            form
        ).val(),
        countryCode: $('select[name$=_country]', form).val(),
        phone: $('input[name$=_phone]', form).val(),
        custom: {
            number: $('input[name$=_number]', form).val(),
            apartment: $('input[name$=_apartment]', form).val(),
            observation: $('input[name$=_observation]', form).val()
        }
    };
    return address;
}

module.exports = {
    showDetails: base.showDetails,
    addNewAddress: base.addNewAddress,
    methods: {
        populateAddressSummary: populateAddressSummary,
        optionValueForAddress: optionValueForAddress,
        getAddressFieldsFromUI: getAddressFieldsFromUI
    }
};
